import { ApiResponse } from "../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";

const SERVICE_URL = ServiceEndPoint.account_service; 

export async function submitInventoryStatus(payload:any): Promise<ApiResponse<any>>{
    const response = await axiosService.post(`${SERVICE_URL}lookup`, payload);
    return response.data;
  }
  
  export async function getInventoryStatus(): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}lookup/inventories.status`);
    return response.data;
  }